/* eslint-disable react/jsx-no-target-blank */
import clsx from 'clsx';
import { useIntl } from 'react-intl';
import { useParams } from 'react-router-dom';
import {
  MerchantStatus,
  MerchantType,
} from '../../../../../pages/siteIntelligence/client/mappings';
import MultiSelection from '../../components/MultiSelection';
import SearchInputGroup from '../../components/SearchInputGroup';
import { useFilter } from '../../FilterContext';
import DatePickerFilter from '../components/DatePickerFilter';
import { zonedTimeToUtc } from 'date-fns-tz';
import { endOfDay } from 'date-fns';

interface SelectType {
  readonly value: string | string[];
  readonly label: string;
}

export function CdrnCaseFilter() {
  const params = useParams();
  const intl = useIntl();
  const { globalFilter, setGlobalFilter } = useFilter();

  return (
    <>
      <div className={clsx(params.id ? 'blur' : '')}>
        {/* Search */}
        <SearchInputGroup
          inputs={[
            { key: 'case_id', title: 'Case ID', minWidth: 100 },
            { key: 'case.authorizationCode', title: 'Auth. Code', minWidth: 100 },
            { key: 'case.bin', title: 'Card BIN', minWidth: 100 },
            { key: 'case.lastFour', title: 'Card Last Four', minWidth: 100 },
            { key: 'case.paymentDescriptor', title: 'Payment Descriptor', minWidth: 100 },
            { key: 'merchant_id', title: 'Client ID', minWidth: 100 },
          ]}
          section='cdrnCaseList'
          globalFilterValue={globalFilter}
          onSubmit={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              cdrnCaseList: { ...globalFilter.cdrnCaseList, ...searchValues },
            })
          }
          onClear={(searchValues) =>
            setGlobalFilter({
              ...globalFilter,
              cdrnCaseList: { ...globalFilter.cdrnCaseList, ...searchValues },
            })
          }
        />

        <div className='hstack justify-content-between align-items-end'>
          {/* Select */}
          <div className='d-flex'>
            {/* Date Picker */}
            <DatePickerFilter
              onChange={(selectedDate) =>
                setGlobalFilter({
                  ...globalFilter,
                  cdrnCaseList: {
                    ...globalFilter.cdrnCaseList,
                    'case.date': selectedDate && {
                      from: zonedTimeToUtc(new Date(selectedDate.start), 'Hongkong').toISOString(),
                      to: zonedTimeToUtc(
                        new Date(endOfDay(selectedDate.end)),
                        'Hongkong'
                      ).toISOString(),
                    },
                  },
                })
              }
              label='Case Date'
              placeholder='Filter Case Date...'
              className='me-6'
            />

            <MultiSelection
              title='Event'
              globalFilterValue={globalFilter?.cdrnCaseList?.['event']?.values}
              options={[
                { value: 'DISPUTE', label: 'Dispute' },
                { value: 'CANCEL', label: 'Cancel' },
              ]}
              onChange={(e) => {
                const values = []
                e.forEach((option) => {
                  values.push(option)
                })
                setGlobalFilter({ ...globalFilter, cdrnCaseList: { ...globalFilter.cdrnCaseList, event: { type: "in", values: values } } });
              }}
            />

            {/* <MultiSelection
              title='Status'
              globalFilterValue={globalFilter?.cdrnCaseList?.['status']?.values}
              options={[
                { value: 'PENDING', label: 'Pending' },
                { value: 'PROCESSING', label: 'Processing' },
                { value: 'COMPLETED', label: 'Completed' },
                { value: 'FAILED', label: 'Failed' },
              ]}
              onChange={(e) => {
                const values = []
                e.forEach((option) => {
                  values.push(option)
                })
                setGlobalFilter({ ...globalFilter, cdrnCaseList: { ...globalFilter.cdrnCaseList, status: { type: "in", values: values } } });
              }}
            /> */}
          </div>
        </div>
      </div>
    </>
  );
}
